import { render, staticRenderFns } from "./RtcGroupVideo.vue?vue&type=template&id=ce7c2d4a&scoped=true"
import script from "./RtcGroupVideo.vue?vue&type=script&lang=js"
export * from "./RtcGroupVideo.vue?vue&type=script&lang=js"
import style0 from "./RtcGroupVideo.vue?vue&type=style&index=0&id=ce7c2d4a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce7c2d4a",
  null
  
)

export default component.exports